var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVkLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8218 32.3705V26.809C28.3669 27.3785 29.4877 30.3184 31.7451 32.3705H37.5C36.0612 28.9858 33.9145 25.9879 31.2205 23.6011C33.2872 20.6026 35.481 17.78 36.5541 13.5H31.3238C29.2731 16.7749 28.1921 20.611 24.8218 23.1404V13.5H17.2308L19.0431 15.8619V24.2795C16.1021 23.9194 14.1149 18.249 11.9608 13.5H6.5C8.48718 19.9158 12.6682 33.9954 24.8218 32.3705Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkLogoLight);
export default __webpack_public_path__ + "static/media/vk-logo-light.9a9f35296b9f795a78e320db38fbb081.svg";
export { ForwardRef as ReactComponent };